import Navbar from "../components/Navbar";
import Carousel from "../components/home/Carousel";
import Footer from "../components/Footer";
import ProductPage from "../components/home/Card";
import Whychoose from "../components/home/Whychoose";
import TopSellingBlinds from "../components/home/Topsellingblinds";
// import { Testimonials } from "../components/home/Testimonials";

const Home = () => {
  return (
    <>
      <div>
        <Navbar />
      </div>

      <div>
        <Carousel />
      </div>
      <div>
        <div className="text-center pt-4 mb-8">
          <h1 className="text-4xl pt-4 font-bold text-[#003EA1]">
            Shop Custom Window Blinds
          </h1>
          <p className="text-lg text-[#01A9DE] mt-2">
            Get the best blinds for your window
          </p>
        </div>
        <ProductPage />
      </div>
      <div>
        <Whychoose />
      </div>
      <div>
        <TopSellingBlinds/>
      </div>
      {/* <div>
        <Testimonials />
      </div> */}
      <div>
        <Footer />
      </div>
    </>
  );
};

export default Home;
